<template>
  <div
    id="app"
    class="custom-theme"
  >
    <TheGlobalNotifications />
    <RouterView />
    <AppModalForm />
  </div>
</template>

<script>
import TheGlobalNotifications from './components/TheGlobalNotifications.vue';
import AppModalForm from './components/AppModalForm.vue';
import freshChat from './lib/freshChat';

export default {
  name: 'App',
  components: {
    TheGlobalNotifications,
    AppModalForm,
  },
  async beforeMount() {
    await this.initializeCatalogSat();

    window.addEventListener('resize', (event) => {
      this.$store.commit('ui/setValue', {
        accessor: 'isMobile',
        value: event.target.innerWidth <= 768,
      });
    });
    freshChat();
    const canTgPoll = (window.fcWidget && window.fcWidget.isInitialized() === true)
      && (window.FMApi && typeof window.FMApi === 'function');

    if (canTgPoll) window.FMApi.triggerPoll();
  },
  mounted() {
    const inlineManualScript = document.createElement('script');
    inlineManualScript.src = process.env.VUE_APP_INLINE_MANUAL;
    document.body.appendChild(inlineManualScript);
  },
  methods: {
    async initializeCatalogSat() {
      await Promise.all([
        this.$store.dispatch('ui/requestCatalogSat', 'taxRegime'),
        this.$store.dispatch('ui/requestCatalogSat', 'relationType'),
        this.$store.dispatch('ui/requestCatalogSat', 'cfdiUse'),
      ]);
    },
  },
};
</script>

<style src="@mdi/font/css/materialdesignicons.min.css"></style>

<style lang="sass">
.is-centered
  display: flex!important
  justify-content: center!important
  align-items: center!important

.hero.is-fullheight
  width: 100%

@import "bulma/bulma"
@import "bulma-checkradio/src/sass/index"
@import "bulma-pageloader/src/sass/index"
@import "bulma-tooltip/src/sass/index"
@import "buefy/src/scss/buefy.scss"

</style>

<style lang="sass">
html,
body
  overflow: auto
  height: 100vh
  width: 100vw

#app
  input.input[type="email"]
    text-transform: lowercase

  input.input:invalid:not(:focus):not(:placeholder-shown)
    box-shadow: 0 0 0 0.125em rgba(255,56,96,.25)
    border-color: #ff3860

  input.input ~ .help.is-danger
    display: none

  input:invalid:not(:focus):not(:placeholder-shown) ~ .help.is-danger
    display: inherit

  .is-fullwidth
    width: 100%

    select,
    .select
      width: 100%

  .table-wrapper
    position: relative

.notices
  padding: 1rem!important

.manifesto-container
  width: 970px
  height: 600px

  iframe.manifesto
    width: 100%
    height: 100%
</style>

<style>
@media screen and (min-width: 769px) {
  .is-centered-tablet {
    display: flex!important;
    justify-content: center!important;
    align-items: center!important;
  }
}

header.navbar.is-primary.is-fixed-top.has-shadow {
  z-index: 999;
}

.mdi.mdi-24px {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vue-radial-menu-item a.action-option {
  color: white;
}
</style>
